export const DEFAULT_PAGE_SIZE = 50;
export const END_OF_QUEUE = 'END_OF_QUEUE';